const createProgram = ({
  name,
  type,
  sourceUrl,
  mapListingUrl,
  mapSearchQuery,
  mapEmbedUrl,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  address,
}) => ({
  name,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  mapListingUrl,
  mapEmbedUrl: mapEmbedUrl || `https://www.google.com/maps?q=${encodeURIComponent(mapSearchQuery)}&output=embed`,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions', admissions],
  ],
  paragraphs: [
    focus,
    'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
  ],
  highlights,
  address,
});

export const programs = [
  {
    name: 'Quality Training Centers',
    type: 'Accelerated adult trade training',
    credential: 'Targeted certificate of completion; verify the current track',
    format: 'Accelerated classroom and hands-on workshop training',
    length: 'Varies by selected training track',
    tuition: 'Varies by track; request current program fees',
    admissions: 'Contact the school for current enrollment requirements',
    summary: 'Quality Training Centers in Las Vegas delivers practical, accelerated trade instruction tailored to adult learners seeking rapid entry into HVAC and mechanical service careers. The school emphasizes hands-on diagnostics, electrical troubleshooting, and foundational climate-control systems in a supportive workshop setting.',
    badge: 'Accelerated adult trade training',
    websiteUrl: 'https://www.qualitytrainingcenters.com/',
    sourceUrl: 'https://www.qualitytrainingcenters.com/',
    mapListingUrl: 'https://maps.google.com/?cid=16645231262071138182&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps?q=Quality%20Training%20Centers%20Las%20Vegas%20Nevada&output=embed',
    specs: [
      ['Program type', 'Accelerated adult trade training'],
      ['Credential', 'Targeted certificate of completion; verify the current track'],
      ['Class format', 'Accelerated classroom and hands-on workshop training'],
      ['Program length', 'Varies by selected training track'],
      ['Tuition and fees', 'Varies by track; request current program fees'],
      ['Admissions', 'Contact the school for current enrollment requirements'],
    ],
    paragraphs: [
      'Quality Training Centers focuses on practical skill development for adults who want a direct route into local mechanical service work. Ask about workshop hours, diagnostic equipment, electrical troubleshooting practice, certificate requirements, scheduling, and contractor connections in Southern Nevada.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Accelerated training designed for adult learners',
      'Hands-on diagnostics and electrical troubleshooting',
      'Targeted completion certificates for local contractor opportunities',
    ],
    address: 'Quality Training Centers, Las Vegas, NV',
  },
  {
    name: 'National Technical Institute',
    type: 'Career-focused HVAC/R technical training',
    credential: 'HVAC/R training with EPA Section 608 Universal preparation',
    format: 'Classroom instruction and extensive hands-on lab practice',
    length: 'Verify the current program duration and schedule',
    tuition: 'Request current tuition, fees, and financing information',
    admissions: 'Contact the Las Vegas campus for current enrollment requirements',
    summary: 'National Technical Institute on East Patrick Lane offers intensive HVAC/R training built around the demands of the modern service industry. The program combines classroom lessons with extensive lab practice covering residential and light commercial equipment, electrical schematics, and refrigeration cycles.',
    badge: 'Career-focused HVAC/R technical training',
    websiteUrl: 'https://www.ntitraining.com/locations/las-vegas/?ref=gbp_lv',
    sourceUrl: 'https://www.ntitraining.com/locations/las-vegas/?ref=gbp_lv',
    mapListingUrl: 'https://maps.google.com/?cid=6717651023591149990&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps?q=National%20Technical%20Institute%20East%20Patrick%20Lane%20Las%20Vegas%20Nevada&output=embed',
    specs: [
      ['Program type', 'Career-focused HVAC/R technical training'],
      ['Credential', 'HVAC/R training with EPA Section 608 Universal preparation'],
      ['Class format', 'Classroom instruction and extensive hands-on lab practice'],
      ['Program length', 'Verify the current program duration and schedule'],
      ['Tuition and fees', 'Request current tuition, fees, and financing information'],
      ['Admissions', 'Contact the Las Vegas campus for current enrollment requirements'],
    ],
    paragraphs: [
      'NTI offers flexible day and evening scheduling for students preparing for service careers. Confirm the current lab sequence, residential and light commercial equipment coverage, refrigeration training, electrical schematic practice, and EPA Section 608 Universal testing support.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Day and evening scheduling options',
      'Residential and light commercial HVAC/R lab training',
      'Preparation for EPA Section 608 Universal certification',
    ],
    address: 'National Technical Institute, East Patrick Lane, Las Vegas, NV',
  },
  {
    name: 'Hands On HVAC School',
    type: 'Hands-on HVAC technician training',
    credential: 'Practical HVAC training certificate',
    format: 'Shop-floor instruction with direct equipment practice',
    length: 'Verify the current course schedule and completion timeline',
    tuition: 'Request current tuition, equipment, and materials costs',
    admissions: 'Contact the school for current enrollment requirements',
    summary: 'Hands On HVAC School on West Post Road provides an immersive shop-floor learning environment for aspiring heating and cooling technicians. The curriculum concentrates on direct equipment diagnostics, component replacement, and wiring fundamentals under experienced trade instructors.',
    badge: 'Hands-on HVAC technician training',
    websiteUrl: 'https://handsonhvacschool.com/lasvegas/',
    sourceUrl: 'https://handsonhvacschool.com/lasvegas/',
    mapListingUrl: 'https://maps.google.com/?cid=8496917469068535689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps?q=Hands%20On%20HVAC%20School%20West%20Post%20Road%20Las%20Vegas%20Nevada&output=embed',
    specs: [
      ['Program type', 'Hands-on HVAC technician training'],
      ['Credential', 'Practical HVAC training certificate'],
      ['Class format', 'Shop-floor instruction with direct equipment practice'],
      ['Program length', 'Verify the current course schedule and completion timeline'],
      ['Tuition and fees', 'Request current tuition, equipment, and materials costs'],
      ['Admissions', 'Contact the school for current enrollment requirements'],
    ],
    paragraphs: [
      'Hands On HVAC School strips away unnecessary filler and concentrates on skills technicians use in entry-level service roles. Ask about diagnostic exercises, component replacement, wiring practice, equipment access, instructor experience, and certificate requirements.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Immersive shop-floor learning environment',
      'Equipment diagnostics and component replacement practice',
      'Training certificate focused on entry-level service readiness',
    ],
    address: 'Hands On HVAC School, West Post Road, Las Vegas, NV',
  },
  {
    name: 'HVAC Air Conditioning Academy',
    type: 'Career-oriented HVAC trade training',
    credential: 'Recognized program certificate; verify the current credential',
    format: 'Career-focused classroom and practical trade instruction',
    length: 'Verify the current program length and class schedule',
    tuition: 'Request current tuition, fees, and materials information',
    admissions: 'Contact the academy for current enrollment requirements',
    summary: 'HVAC Air Conditioning Academy on East Tropicana Avenue offers accessible, career-oriented trade training for working adults in Southern Nevada. The program emphasizes system maintenance, installation procedures, and troubleshooting for residential and commercial heating and cooling equipment.',
    badge: 'Career-oriented HVAC trade training',
    websiteUrl: 'https://hvacairconditioningacademy.com/',
    sourceUrl: 'https://hvacairconditioningacademy.com/',
    mapListingUrl: 'https://maps.google.com/?cid=4348909471788690574&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps?q=HVAC%20Air%20Conditioning%20Academy%20East%20Tropicana%20Avenue%20Las%20Vegas%20Nevada&output=embed',
    specs: [
      ['Program type', 'Career-oriented HVAC trade training'],
      ['Credential', 'Recognized program certificate; verify the current credential'],
      ['Class format', 'Career-focused classroom and practical trade instruction'],
      ['Program length', 'Verify the current program length and class schedule'],
      ['Tuition and fees', 'Request current tuition, fees, and materials information'],
      ['Admissions', 'Contact the academy for current enrollment requirements'],
    ],
    paragraphs: [
      'The academy is structured to help students fit HVAC education around varied schedules while developing job-ready technical skills. Ask about maintenance labs, installation practice, commercial equipment coverage, troubleshooting instruction, certificate details, and local contractor pathways.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Scheduling designed for working adults',
      'Residential and commercial system maintenance training',
      'Installation and troubleshooting instruction',
    ],
    address: 'HVAC Air Conditioning Academy, East Tropicana Avenue, Las Vegas, NV',
  },
  {
    name: 'UEI - Las Vegas',
    type: 'Accelerated career training program',
    credential: 'HVAC diploma with EPA Section 608 preparation',
    format: 'Hybrid online instruction and on-campus laboratory training',
    length: 'Approximately 10 months; verify current schedule',
    tuition: 'Request current tuition, fees, tools, and financial-aid information',
    admissions: 'Review current UEI Las Vegas admissions requirements',
    summary: 'UEI College in Las Vegas offers an accelerated hybrid HVAC program that can be completed in approximately 10 months. Online instructional modules are paired with on-campus labs covering electrical circuits, motors, automatic controls, and air distribution systems.',
    badge: 'Accelerated career training program',
    websiteUrl: 'https://www.uei.edu/trade-school/nevada/las-vegas/',
    sourceUrl: 'https://www.uei.edu/trade-school/nevada/las-vegas/',
    mapListingUrl: 'https://maps.google.com/?cid=3433910056263223468&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps?q=UEI%20College%20Las%20Vegas%20Nevada&output=embed',
    specs: [
      ['Program type', 'Accelerated career training program'],
      ['Credential', 'HVAC diploma with EPA Section 608 preparation'],
      ['Class format', 'Hybrid online instruction and on-campus laboratory training'],
      ['Program length', 'Approximately 10 months; verify current schedule'],
      ['Tuition and fees', 'Request current tuition, fees, tools, and financial-aid information'],
      ['Admissions', 'Review current UEI Las Vegas admissions requirements'],
    ],
    paragraphs: [
      'UEI is designed for students seeking a structured, accelerated route into HVAC work. Ask about the online-to-lab schedule, electrical and controls coursework, air distribution practice, EPA Section 608 testing support, diploma requirements, career services, and employer networking.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Approximately 10-month accelerated program',
      'Hybrid online coursework and campus labs',
      'Career services and local employer networking support',
    ],
    address: 'UEI College, Las Vegas, NV',
  },
  {
    name: 'College of Southern Nevada',
    type: 'Public college air conditioning technology program',
    credential: 'Certificates of achievement and Associate of Applied Science degree',
    format: 'College classroom instruction and hands-on laboratory training',
    length: 'Varies by certificate or degree pathway',
    tuition: 'Competitively priced in-state tuition; financial aid may be available to qualifying students',
    admissions: 'Review current CSN admissions, program, and financial-aid requirements',
    summary: 'As part of the public college system in Southern Nevada, the College of Southern Nevada offers comprehensive Air Conditioning Technology pathways ranging from stackable certificates of achievement to a full Associate of Applied Science degree. The curriculum combines classroom theory with hands-on lab experience to prepare graduates for HVAC technician careers and industry certifications.',
    badge: 'Public college air conditioning technology program',
    websiteUrl: 'https://www.csn.edu/schools/school-of-advanced-and-applied-technologies/department-of-applied-technologies/air-conditioning-technology-program',
    sourceUrl: 'https://www.csn.edu/schools/school-of-advanced-and-applied-technologies/department-of-applied-technologies/air-conditioning-technology-program',
    mapListingUrl: 'https://maps.google.com/?cid=12143040407116817291&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d412344.332990234!2d-115.8419787109375!3d36.1558437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8c11e9d5d9ff3%3A0x27dcc6b90634ddac!2sCollege%20of%20Southern%20Nevada!5e0!3m2!1sen!2sus!4v1790274812808!5m2!1sen!2sus',
    specs: [
      ['Program type', 'Public college air conditioning technology program'],
      ['Credential', 'Certificates of achievement and Associate of Applied Science degree'],
      ['Class format', 'College classroom instruction and hands-on laboratory training'],
      ['Program length', 'Varies by certificate or degree pathway'],
      ['Tuition and fees', 'Competitively priced in-state tuition; financial aid may be available to qualifying students'],
      ['Admissions', 'Review current CSN admissions, program, and financial-aid requirements'],
    ],
    paragraphs: [
      'CSN provides a structured academic pathway for students who want comprehensive HVAC education in Southern Nevada. Coursework covers electrical theory, heating systems, commercial refrigeration, and automated controls while giving students practical lab experience. Ask about stackable certificates, degree requirements, lab hours, transfer options, and current industry certification preparation.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Stackable certificates and an Associate of Applied Science pathway',
      'Electrical theory, heating systems, and commercial refrigeration',
      'Automated controls and hands-on laboratory experience',
      'Competitive in-state tuition and potential financial-aid support',
    ],
    address: 'College of Southern Nevada, Las Vegas, NV',
  },
  {
    name: 'Advanced Service & Repair School',
    type: 'Focused vocational HVAC service training',
    credential: 'Specialized HVAC service training certificate',
    format: 'Fast-paced vocational instruction with hands-on repair training',
    length: 'Verify the current program duration and class schedule',
    tuition: 'Request current tuition, tools, and materials costs',
    admissions: 'Contact the school for current enrollment requirements',
    summary: 'Advanced Service & Repair School in Las Vegas delivers fast-paced, highly focused vocational training designed to prepare students for the mechanical service industry. The program emphasizes practical diagnostics, troubleshooting, and direct repair techniques for residential and commercial heating and cooling equipment.',
    badge: 'Focused vocational HVAC service training',
    websiteUrl: 'https://acrepairschoollasvegas.com/',
    sourceUrl: 'https://acrepairschoollasvegas.com/',
    mapListingUrl: 'https://maps.google.com/?cid=12850912170364955761&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3223.900834490746!2d-115.2068405!3d36.0959053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8c68a1d0c7237%3A0x1b5392bd35fa7136!2sAdvanced%20Training%20Institute%2C%20Inc.!5e0!3m2!1sen!2smx!4v1790274900455!5m2!1sen!2smx',
    specs: [
      ['Program type', 'Focused vocational HVAC service training'],
      ['Credential', 'Specialized HVAC service training certificate'],
      ['Class format', 'Fast-paced vocational instruction with hands-on repair training'],
      ['Program length', 'Verify the current program duration and class schedule'],
      ['Tuition and fees', 'Request current tuition, tools, and materials costs'],
      ['Admissions', 'Contact the school for current enrollment requirements'],
    ],
    paragraphs: [
      'Advanced Service & Repair School concentrates on the direct mechanical competencies used by entry-level service technicians. Ask about residential and commercial equipment access, diagnostic exercises, troubleshooting scenarios, repair techniques, instructor support, certificate requirements, and local contractor employment connections.',
      'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
    ],
    highlights: [
      'Fast-paced training focused on mechanical service',
      'Hands-on diagnostics and troubleshooting practice',
      'Residential and commercial heating and cooling repair techniques',
      'Specialized certificate for entry-level employment preparation',
    ],
    address: 'Advanced Service & Repair School, Las Vegas, NV',
  },
];

export const resources = [
  {
    title: 'Air-Conditioning, Heating, and Refrigeration Institute',
    description: 'Explore industry standards, equipment efficiency information, and HVAC career resources.',
    url: 'https://www.ahrinet.org/',
  },
  {
    title: 'EPA Section 608 Technician Certification',
    description: 'Review federal refrigerant handling requirements and approved certification programs.',
    url: 'https://www.epa.gov/section608',
  },
  {
    title: 'Nevada State Contractors Board',
    description: 'Review Nevada contractor licensing information and requirements for HVAC-related work.',
    url: 'https://www.nvcontractorsboard.com/',
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description: 'Research HVAC mechanic and installer duties, pay, education, and employment outlook.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm',
  },
];